import React from 'react';
import PropTypes from 'prop-types';

const LivesWithFamily = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2 9 6.238-4.265C9.932 3.578 10.778 3 11.808 3c1.029 0 1.876.578 3.57 1.735L21.615 9M3.962 8v12m15.692 0V8M2 20h19.615M8.538 20v-4c0-.943 0-1.414.384-1.707C9.305 14 9.92 14 11.154 14h1.307c1.234 0 1.85 0 2.233.293s.383.764.383 1.707v4M10.5 11h2.615M10.5 8h2.615"
    />
  </svg>
);

LivesWithFamily.propTypes = {
  color: PropTypes.string
};

export default LivesWithFamily;
